import { meSessionQueryOptions } from '@features/me/queries'
import { canAccessPortalAdministration } from '@features/portal-administration/access'
import { PortalAdministration } from '@features/portal-administration/components/PortalAdministration'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/admin')({
    beforeLoad: async ({ context }) => {
        if (context.auth.hostMode !== 'staff') {
            throw redirect({ to: '/home' })
        }

        const session = await context.queryClient.ensureQueryData(meSessionQueryOptions())
        const actualRoles = session.actualStaffProfile?.roles.map((role) => role.code) ?? []
        const canAdminPortal = canAccessPortalAdministration(actualRoles)
        const isDev = actualRoles.includes('dev')

        if (!canAdminPortal && !isDev) {
            throw redirect({ to: '/home' })
        }
    },
    component: RouteComponent,
})

function RouteComponent() {
    return <PortalAdministration />
}
